import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";

import { dataToJS, pathToJS, firebaseConnect } from "react-redux-firebase";
import BlankPage from "../blank/";

class LogTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      logs: this.props.group.logs
    };
  }

  componentWillMount() {}

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.state = {
      logs: this.props.group.logs
    };
  }

  updateLog(logId, role, value) {
    this.props.firebase.set(
      `/groups/${this.props.group._key}/logs/${logId}/isActive/${role}`,
      value
    );
    this.state.logs[logId].isActive[role] = value;
    this.setState(this.state);
    console.log(this.props.group._key, logId, role, value);
  }

  update(value) {}

  render() {
    if (this.props.group && this.props.logs) {
      return (
        <table>
          <tbody>
            <tr>
              <th>Ignorance Logs</th>
              <th>High School</th>
              <th>Undergrad</th>
              <th>Medical Student</th>
            </tr>

            {this.props.logs &&
              Object.keys(this.props.logs)
                .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                .filter(log => log.type === "log")
                .sort((a, b) => a.order - b.order)
                .map(log => (
                  <tr key={`${this.props.group._key}${log._key}`}>

                    <td>{log.title}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.highschool
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "highschool",
                            e.target.checked
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.undergrad
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "undergrad",
                            e.target.checked
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.gradstudent
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "gradstudent",
                            e.target.checked
                          );
                        }}
                      />
                    </td>

                  </tr>
                ))}
            <tr>
              <th>Surveys</th>
              <th>High School</th>
              <th>Undergrad</th>
              <th>Medical Student</th>
            </tr>
            {this.props.group &&
              this.props.logs &&
              Object.keys(this.props.logs)
                .map((key, id) => ({ ...this.props.logs[key], _key: key }))
                .filter(log => log.type === "survey")
                .sort((a, b) => a.order - b.order)
                .map(log => (
                  <tr key={`${this.props.group._key}${log._key}`}>
                    <td>{log.title}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.highschool
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "highschool",
                            e.target.checked
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.undergrad
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "undergrad",
                            e.target.checked
                          );
                        }}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={
                          this.state.logs &&
                            this.state.logs[log._key] &&
                            this.state.logs[log._key].isActive &&
                            this.state.logs[log._key].isActive.gradstudent
                        }
                        onChange={e => {
                          this.updateLog(
                            log._key,
                            "gradstudent",
                            e.target.checked
                          );
                        }}
                      />
                    </td>

                  </tr>
                ))}
          </tbody>
        </table>
      );
    }
  }
}

export default firebaseConnect()(LogTable);



// WEBPACK FOOTER //
// ./src/routes/group-logs/logs-table.js